const dateKeys=['date','documentDate','billDate','receivedAt','invoiceDate','completedAt','placedAt','createdAt'];
export function compareReportRows(a,b,field,direction='asc') {
  const key=field==='__date'?dateKeys.find(k=>a[k]!=null||b[k]!=null):field;
  if(!key)return 0;
  const x=a[key],y=b[key];
  if(x==null||x==='')return y==null||y===''?0:1;
  if(y==null||y==='')return -1;
  let cmp;
  if(dateKeys.includes(key)){const dx=Date.parse(x),dy=Date.parse(y);cmp=Number.isFinite(dx)&&Number.isFinite(dy)?dx-dy:String(x).localeCompare(String(y),undefined,{numeric:true});}
  else if(typeof x==='number'&&typeof y==='number')cmp=x-y;
  else cmp=String(x).localeCompare(String(y),undefined,{numeric:true,sensitivity:'base'});
  return direction==='desc'?-cmp:cmp;
}
export function sortReport(report,field,direction) {
  if(!report||typeof report!=='object')return report;
  if(Array.isArray(report))return report.map(r=>sortReport(r,field,direction)).sort((a,b)=>a&&b&&typeof a==='object'&&typeof b==='object'?compareReportRows(a,b,field,direction):0);
  return Object.fromEntries(Object.entries(report).map(([k,v])=>[k,typeof v==='object'?sortReport(v,field,direction):v]));
}
export function reportFields(report){
  const fields=new Set();
  const visit=value=>{if(Array.isArray(value))value.forEach(row=>{if(row&&typeof row==='object'){Object.entries(row).forEach(([key,v])=>{if(v!=null&&['string','number'].includes(typeof v)&&!/(^id$|Id$)/.test(key))fields.add(key);});visit(row);}});else if(value&&typeof value==='object')Object.values(value).forEach(v=>{if(typeof v==='object')visit(v);});};
  visit(report);return [...fields];
}
